import { useTranslation } from 'react-i18next';

import Photo from '../Photo';
import { getListingById } from '../../data/listings';

export default function OurDifference() {
  const { t } = useTranslation();
  // photos[5] === 05-kitchen: white kitchen with island + pendant cluster.
  const primaryPhoto = getListingById('fourways')?.photos[5];
  // 02-pool-1 corresponds to source "3 - Pool 1.jpg".
  const insetPhoto = getListingById('casagrande')?.photos[2];

  return (
    <section
      id="difference"
      className="border-y border-line bg-surface px-6 py-24 md:px-10"
    >
      <div className="mx-auto grid max-w-[1280px] items-center gap-10 md:grid-cols-[0.9fr_1.1fr] md:gap-20">
        <div className="relative">
          <div className="overflow-hidden rounded-xs">
            {primaryPhoto && (
              <Photo
                photo={primaryPhoto}
                alt={t('ourDifference.imagePrimary')}
                ratio="4/5"
                sizes="(min-width: 768px) 40vw, 100vw"
              />
            )}
          </div>
          <div className="absolute -bottom-5 -right-5 hidden w-44 overflow-hidden rounded-xs border-8 border-surface md:block">
            {insetPhoto && (
              <Photo
                photo={insetPhoto}
                alt={t('ourDifference.imageInset')}
                ratio="1/1"
                sizes="176px"
              />
            )}
          </div>
        </div>

        <div>
          <div className="mb-4 text-xs uppercase tracking-[0.12em] text-accent">
            ❋&nbsp;&nbsp;{t('ourDifference.eyebrow')}
          </div>
          <h2 className="m-0 text-balance font-display font-semibold leading-tight tracking-display text-ink [font-size:clamp(36px,4.4vw,60px)]">
            {t('ourDifference.headline')}
          </h2>
          <div className="mt-7 max-w-[600px] text-pretty text-[18px] leading-[1.65] text-muted">
            <p className="mb-5 mt-0">{t('ourDifference.paragraph1')}</p>
            <p className="m-0">{t('ourDifference.paragraph2')}</p>
          </div>

          <a
            href="#stays"
            className="mt-10 inline-flex items-center gap-2.5 rounded-full bg-ink px-5 py-3.5 text-sm font-medium text-surface no-underline transition hover:opacity-90"
          >
            {t('ourDifference.cta')} <span aria-hidden>→</span>
          </a>
        </div>
      </div>
    </section>
  );
}
